import { Container, Col } from '@ui/wrapper'
import { SectionWrapper, StyledRow } from './style'
import BoxImage from '@components/box-large-image/layout-06'

const TopThemenArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        <StyledRow className="justify-content-center d-flex">
          {data.items?.map(
            (item) =>
              item && (
                <Col
                  key={item.id}
                  style={{ marginBottom: 30 }}
                  className="box-item"
                  lg={4}
                  md={6}
                >
                  <BoxImage
                    title={item.title}
                    btnText={item.name}
                    desc={item.description}
                    image={item.images[0]}
                    path={
                      item.pdfs.length > 0
                        ? item.pdfs[0].src.localFile.publicURL
                        : null
                    }
                    url={
                      item.pdfs.length > 0
                        ? item.pdfs[0].src.localFile.publicURL
                        : null
                    }
                  />
                </Col>
              )
          )}
        </StyledRow>
      </Container>
    </SectionWrapper>
  )
}

export default TopThemenArea
